<div class="container">
  <div class="loader" #loader></div>
  @if (text) {
    <div class="text"
      [style.color]="textColor"
    #textElement>{{text}}</div>
  }
</div>
